module.exports = __webpack_public_path__ + "img/AdamNeuhaus.acf81fb9.webp";